import { Tooltip } from "@mui/material";

import styles from "./styles.module.scss";

interface ButtonCreatedProps {
  handleCreateItem: () => void;
}

export function ButtonCreated({ handleCreateItem }: ButtonCreatedProps) {
  return (
    <Tooltip placement="top" title="Criar">
      <button
        type = "button"
        className={`${styles.buttonCreated}`}
        onClick={() => handleCreateItem()}
      ></button>
    </Tooltip>
  );
}